module.exports = __webpack_public_path__ + "img/d201309-3.aa22c687.jpg";